import { useEffect, useRef, useState } from 'react';
import { sendContactFormNotification, submitContactForm } from '../services/api';

const useContactForm = (initial, { resetAfterMs = 0, onSuccess, notifySource = 'contact' } = {}) => {
  const [formData, setFormData] = useState(initial);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const resetTimer = useRef(null);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (error) setError(null);
  };

  const handleSubmit = async (e, payload) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await submitContactForm(payload);
      await sendContactFormNotification(payload.email, payload.message, notifySource);
      setSubmitted(true);
      setFormData(initial);
      onSuccess?.();
      if (resetAfterMs > 0) {
        clearTimeout(resetTimer.current);
        resetTimer.current = setTimeout(() => setSubmitted(false), resetAfterMs);
      }
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return { formData, submitted, setSubmitted, loading, error, handleChange, handleSubmit };
};

export default useContactForm;
